module.exports = __webpack_public_path__ + "img/DROP-4-820x1024.32c15651.png";